import CategoryDndItem from './CategoryDndItem';

export default CategoryDndItem;